declare const $: any;

export function isIE() {
    return (
        // tslint:disable-next-line:triple-equals
        navigator.appName == "Microsoft Internet Explorer" ||
        !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/)) ||
        // tslint:disable-next-line:triple-equals
        (typeof $.browser !== "undefined" && $.browser.msie == 1)
    );
}
